import React, { useContext } from 'react';
import Slider from 'react-slick';
import ConfigContext from '../../contexts/ConfigContext';
import { useGetPodsQuery } from '../../redux/slices/podSlice';

import PodTease from './PodTease';

import 'slick-carousel/slick/slick.css';
import styles from './FeaturedTrucks.module.postcss';

const defaultSettings = {
  slidesToShow: 5,
  slidesToScroll: 2,
  infinite: false,
  lazyLoad: 'anticipated',
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 732,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

function FeaturedPods({ options, sliderSettings }) {
  const settings = { ...defaultSettings, ...sliderSettings };
  const { vehicle_type } = useContext(ConfigContext);
  const { data = {} } = useGetPodsQuery({ page_size: 5, random: true, ...options });
  const pods = data.pods || [];

  if (!pods || pods.length < 1) {
  return null;
  }

  const slides = (pods || []).map((pod) => (
    <div key={'pods-' + pod.id}>
      <PodTease pod={pod} />
    </div>
  ));

  return (
    <div className={styles.FeaturedTrucks}>
      <h2>Popular Food {vehicle_type} Stops</h2>
      <Slider {...settings}>
        {slides}
      </Slider>
    </div>
  );
}

export default FeaturedPods;
